export default __webpack_public_path__ + "static/media/user_square.6ffa0006.svg";